import { useStationStore, type EvseState } from '@/state/useStationStore';
import { ConnectorRow } from './ConnectorRow';

export function EVSECard({ evse }: { evse: EvseState }): JSX.Element {
  const kind = evse.kind ?? (evse.maxPowerW >= 50_000 ? 'DC' : 'AC');
  return (
    <section
      className="rounded-lg border border-slate-700 bg-slate-900/60 p-4 shadow"
      aria-labelledby={`evse-${evse.id}-title`}
      data-testid={`evse-${evse.id}`}
    >
      <header className="mb-3 flex items-baseline justify-between">
        <h2 id={`evse-${evse.id}-title`} className="text-base font-medium text-slate-100">
          {evse.name}
        </h2>
        <span className="text-xs text-slate-400">
          {kind} · {(evse.maxPowerW / 1000).toFixed(0)} kW
        </span>
      </header>
      <ul className="space-y-2">
        {evse.connectorIds.map((cid) => (
          <ConnectorRow key={cid} connectorId={cid} />
        ))}
      </ul>
    </section>
  );
}

// Re-export selector so the page can iterate without re-importing the store.
export function useEvses(): readonly EvseState[] {
  return useStationStore((s) => s.evses);
}
